import React from "react";
import { useLang } from "../../context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

export default function PracticeAreas() {
  const { t } = useLang();
  return (
    <section
      id="practice"
      data-testid="practice-section"
      className="bg-cream-200 text-ink-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-8 md:gap-16 mb-16">
          <div className="md:col-span-5">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-ink-500 mb-6">
              {t.practice.overline}
            </div>
            <h2
              data-testid="practice-title"
              className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-ink-800"
            >
              {t.practice.title}
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-base md:text-lg leading-relaxed text-ink-500 self-end">
            {t.practice.lead}
          </p>
        </div>

        {/* Grid Borders */}
        <div
          data-testid="practice-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-ink-800/15"
        >
          {t.practice.items.map((it, i) => (
            <article
              key={i}
              data-testid={`practice-item-${i}`}
              className="group relative border-r border-b border-ink-800/15 p-8 md:p-10 bg-cream-200 hover:bg-cream-100 transition-colors duration-300"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-xs tracking-widest text-ink-500">
                  {it.n}
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-ink-300 group-hover:text-crimson group-hover:rotate-45 transition-all duration-300"
                />
              </div>
              <h3 className="font-serif text-2xl md:text-[1.75rem] leading-tight text-ink-800 mb-4 text-balance">
                {it.title}
              </h3>
              <p className="text-sm md:text-base text-ink-500 leading-relaxed">
                {it.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
